import { CONTAINER_TYPES_VALUES } from '../../constants';

const getLoadPresentation = (deal) => {
  if (deal.mode.toUpperCase() === 'AIR' || deal.mode.toUpperCase() === 'EXPRESS') {
    return ' | ' + deal.weight + 'kg';
  }
  if (deal.loadUnitTypes && deal?.loadUnitTypes.startsWith('container')) {
    return `${CONTAINER_TYPES_VALUES[deal?.loadUnitTypes]?.label} (x ${
      deal?.loadUnits.split(' ')[0]
    })`;
  }

  return ' | ' + deal?.cbm.toFixed(4) + 'cbm/' + deal?.weight + 'kg';
};

export const normalizeDeals = (deals) =>
  deals.map((deal) => ({
    id: deal?.id,
    origin: {
      country: deal?.origin_Country,
      type: deal?.origintype,
      value: deal?.Origin_port_or_city,
      city: deal?.origincity
    },
    destination: {
      country: deal?.destination_Country,
      type: deal?.destinationtype,
      value: deal.destination_port_or_city,
      city: deal?.destinationcity
    },
    mode: deal?.mode.toUpperCase(),
    provider: deal?.fromBusiness__label,
    services: deal?.services,
    onlyInsurance: deal?.onlyInsurance,
    rating: deal?.rating ? Number((Math.round(deal.rating * 2) / 2).toFixed(1)) : null,
    load: {
      units: deal?.loadUnits.split(' ')[0],
      type: deal?.loadUnitTypes,
      cbm: deal?.cbm,
      weight: deal?.weight,
      value: getLoadPresentation(deal)
    },
    totalPrice: {
      amount: deal?.totalPrice,
      currency: 'USD'
    },
    rfq: deal?.RFQ
  }));
